import React from 'react';

import {observer} from "mobx-react";
import {BoxScoresWidgetAsync} from "../../../box-scores-widget/components/box-scores-widget.async";

export const GameCenterWidgetContentBoxScoresTab = observer(({controller, matchupId, gameId, location, showOdds}) => {
  const {state} = controller;
  const {shouldRenderBoxScores} = state;

  const boxScoresProps = {
    matchupId,
    gameId,
    location,
    showOdds,
  }

  return (shouldRenderBoxScores ? <>
    <BoxScoresWidgetAsync {...boxScoresProps}/>
  </> : null)
});
